import { useWappRoom } from '$logic/wapp-room/react-hook'
import { UserListItemSkeleton } from '$common/user-list-item'
import { openWappProfile } from '$logic/router'
import { useWapp } from '$logic/wapps/react-hook'
import { RoomAppBarInfo } from '$common/room-app-bar/room-app-bar-info'
import { getImageUrl } from '$func/imageUrl'
import { t } from '$i18n'
import { stringToColor } from '$func/string-to-color'

export function WappRoomAppBar({ roomId }: { roomId: string }) {
  const { entity: wappRoom } = useWappRoom(roomId)
  const { wappId = '' } = wappRoom || {}
  const { entity: wapp } = useWapp(wappId)
  if (!wappRoom || !wapp) return <UserListItemSkeleton />
  const { name, image, verified } = wapp

  const avatarBackgroundColor = stringToColor(name, roomId)

  return (
    <RoomAppBarInfo
      onClick={() => openWappProfile(wappRoom.wappId)}
      avatarSrc={getImageUrl(image)}
      primaryText={name}
      secondaryText={t('profile.wapp.tool')}
      verified={verified}
      avatarBackgroundColor={avatarBackgroundColor}
      callElement={null}
    />
  )
}
